/* TLY v3 homepage - tabs (Promotions / New / Buy More Deal). Panels are server-rendered; this only switches them. No fetch. */
(function () {
  function init(root) {
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    var seg = tabs[0].parentNode;
    function show(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) {
          var was = p.hidden;
          p.hidden = !on;
          if (on && was) {
            p.querySelectorAll('.t3-card').forEach(function (c) {
              c.classList.remove('t3-in'); void c.offsetWidth; c.classList.add('t3-in');
              c.addEventListener('animationend', function h() { c.classList.remove('t3-in'); c.removeEventListener('animationend', h); });
            });
          }
        }
        var all = root.querySelector('[data-all="' + t.id + '"]');
        if (all) all.hidden = !on;
      });
      // Steven 10-25: the active tab is brushed gold (CSS .t3-htab.t3-sel), moved instantly; no shared hover fill on these tabs
      tabs.forEach(function (t) { t.classList.toggle('t3-sel', t === tab); });
      tab.setAttribute('aria-current', 'true');
      tabs.forEach(function (t) { if (t !== tab) t.removeAttribute('aria-current'); });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function (e) { e.preventDefault(); show(t, false); });
      t.addEventListener('keydown', function (e) {
        var n = -1;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = tabs.length - 1;
        if (n < 0) return;
        e.preventDefault(); show(tabs[n], true);
      });
    });
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-t3-tabs]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
